import React from "react";
import { Drawer, Table as AntTable, Popconfirm, Space, Tag, Tooltip, Typography, Empty } from "antd";
import styled from "styled-components";
import { useAppData } from "../../store/app-data";
import { Button } from "../../components/actions/button";
import { TrashSvg } from "../../components/Svg";

const { Title, Text } = Typography;

export function CardsDrawer({
    title,
    userId,
    cards,
    isLoading,
    onClose,
    onRefresh,
    onDeleteOne,
    onDeleteAll,
}) {
    const layoutConfig = useAppData((state) => state.layoutConfig);

    async function handleDeleteOne(subscriptionId) {
        await onDeleteOne(userId, subscriptionId);
        await onRefresh(userId);
    }

    async function handleDeleteAll() {
        await onDeleteAll(userId);
        await onRefresh(userId);
    }

    const columns = [
        {
            title: "Маска карты",
            dataIndex: "nameForUser",
            key: "nameForUser",
            render: (text) => text ?? <Text type="secondary">без маски</Text>,
        },
        {
            title: "Юр.лица (PaymentAccount)",
            dataIndex: "paymentAccountIds",
            key: "paymentAccountIds",
            render: (ids) => (
                <Space size={4} wrap>
                    {(ids ?? []).map((id) => (
                        <Tag key={id}>{id}</Tag>
                    ))}
                </Space>
            ),
        },
        {
            title: "Действие",
            key: "action",
            width: 80,
            render: (_, record) => (
                <Tooltip title="Удалить эту карту у всех юр.лиц">
                    <Popconfirm
                        placement="left"
                        title="Удалить карту у всех юр.лиц?"
                        onConfirm={() => handleDeleteOne(record.id)}
                    >
                        <Button size="small" type="link">
                            <TrashSvg />
                        </Button>
                    </Popconfirm>
                </Tooltip>
            ),
        },
    ];

    return (
        <DrawerEdit
            width={layoutConfig.isMobile ? "90%" : "60%"}
            title={title}
            onClose={onClose}
            open
        >
            <HeaderRow>
                <Title level={5} style={{ margin: 0 }}>
                    Сохранённые карты клиента
                </Title>
                <Popconfirm
                    placement="left"
                    title="Удалить все карты клиента?"
                    onConfirm={handleDeleteAll}
                    disabled={!cards?.length}
                >
                    <Button danger disabled={!cards?.length}>
                        Удалить все
                    </Button>
                </Popconfirm>
            </HeaderRow>

            {(!isLoading && (!cards || cards.length === 0)) ? (
                <Empty description="У клиента нет сохранённых карт" />
            ) : (
                <StyledTable
                    rowKey="id"
                    dataSource={cards}
                    columns={columns}
                    loading={isLoading}
                    pagination={false}
                />
            )}
        </DrawerEdit>
    );
}

const DrawerEdit = styled(Drawer)``;

const HeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    gap: 12px;
`;

const StyledTable = styled(AntTable)`
    .ant-table-row {
        background: #ffffff;
    }
`;
